var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) {
        Object.defineProperty(cooked, "raw", { value: raw });
    }
    else {
        cooked.raw = raw;
    }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function (t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
// CenterModal.tsx - обновите стили для позиционирования по центру
import styled from 'styled-components';
var CenterModalWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.5); /* \u0437\u0430\u0442\u0435\u043C\u043D\u0435\u043D\u0438\u0435 \u0444\u043E\u043D\u0430 */\n  z-index: 1000;\n"], ["\n  display: ", ";\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  justify-content: center;\n  align-items: center;\n  background: rgba(0, 0, 0, 0.5); /* \u0437\u0430\u0442\u0435\u043C\u043D\u0435\u043D\u0438\u0435 \u0444\u043E\u043D\u0430 */\n  z-index: 1000;\n"])), function (_a) {
    var show = _a.show;
    return (show ? 'flex' : 'none');
});
var ModalContent = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background: #EFF0F4;\n  padding: 40px;\n  border-radius: 8px;\n  width: 70vw;\n  max-height: 80vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"], ["\n  background: #EFF0F4;\n  padding: 40px;\n  border-radius: 8px;\n  width: 70vw;\n  max-height: 80vh;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n"])));
var CenterClientsModal = function (_a) {
    var show = _a.show, handleClose = _a.handleClose, children = _a.children;
    return (_jsx(CenterModalWrapper, __assign({ show: show, onClick: handleClose }, { children: _jsx(ModalContent, __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: children })) })));
};
export default CenterClientsModal;
var templateObject_1, templateObject_2;
